// extracted by mini-css-extract-plugin
export default {"header":"DangerAlert_header__KmbHJ","title":"DangerAlert_title__E6K4z","footer":"DangerAlert_footer__y9VKM","body":"DangerAlert_body__TceXd"};